/*
This mixin needs the following variables in the parent component
  data:     resourceName
  data:     createMutation
  data:     updateMutation
  data:     editableItems
  method:   getEditedItem
  method:   setEditedItem
  method:   optimistic
  method:   cancelOptimistic
*/

export default {
  props: {
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      editedItem: null,
      editedItemId: null
    };
  },
  methods: {
    newItem() {
      for (let i = 0; i < this.editableItems.length; i++)
        if (this.editableItems[i].id === "new") return;

      this.editedItem = this.initItem();
      this.editableItems.unshift(this.editedItem);
      this.editedItemId = "new";
    },
    createOrUpdateItem() {
      this.editedItemId = null;
      //this.optimistic();
      if (this.editedItem.id === "new") {
        this.create();
      } else {
        this.optimistic();
        this.update();
      }
    },
    create() {
      this.sendMutation(
        "created",
        this.resourceName,
        this.createMutation,
        this.getEditedItem()
      ).catch(() => {
        this.cancelOptimistic();
      });
    },
    update() {
      this.sendMutation(
        "updated",
        this.resourceName,
        this.updateMutation,
        this.getEditedItem()
      ).catch(() => {
        this.cancelOptimistic();
      });
    },
    edit(item) {
      if (this.editedItemId !== item.id && this.editable) {
        if (this.editedItemId) {
          this.endEdit();
        } else {
          this.editedItemId = item.id;
          this.setEditedItem(item);
        }
      }
    },
    endEdit() {
      if (this.editedItemId === "new")
        for (let i = 0; i < this.editableItems.length; i++) {
          if (this.editableItems[i].id === "new") {
            this.editableItems.splice(i, 1);
            break;
          }
        }
      this.editedItemId = null;
    },
    isEdited(item) {
      return this.editedItemId === item.id;
    }
  },
  watch: {
    editableItems() {
      if (
        this.editedItemId &&
        !this.editableItems.find(e => e.id === this.editedItemId)
      ) {
        this.editedItemId = null;
      }
    }
  }
};
